import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-col"
};
const _hoisted_2 = {
  class: "flex-center"
};
const _hoisted_3 = {
  class: "flex-center"
};
const _hoisted_4 = {
  class: "flex-1 mr-0.5"
};
const _hoisted_5 = {
  class: "flex-1 ml-0.5"
};
import Progress from "@/modules/vue/components/Progress.vue";
import { ColorEnum } from "@/modules/vue/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'LiveMatchStat',
  props: {
    label: null,
    homeValue: null,
    awayValue: null,
    percentage: {
      type: Boolean
    },
    color: {
      default: ColorEnum.Slate
    }
  },
  setup(__props) {
    const props = __props;
    const divider = computed(() => Math.max(props.homeValue, props.awayValue));
    const progressHomeValue = computed(() => divider.value === 0 ? 0 : props.homeValue / divider.value * 100);
    const progressAwayValue = computed(() => divider.value === 0 ? 0 : props.awayValue / divider.value * 100);
    const progressHomeValueLabel = computed(() => {
      if (props.percentage) {
        return Math.round(props.homeValue / (props.homeValue + props.awayValue) * 100) + '%';
      }
      return props.homeValue;
    });
    const progressAwayValueLabel = computed(() => {
      if (props.percentage) {
        return Math.round(props.awayValue / (props.homeValue + props.awayValue) * 100) + '%';
      }
      return props.awayValue;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "label", {}, () => [_createTextVNode(_toDisplayString(__props.label), 1)])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(Progress, {
        value: _unref(progressHomeValue),
        color: __props.color,
        "show-value": "",
        reverse: ""
      }, {
        value: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(progressHomeValueLabel)), 1)]),
        _: 1
      }, 8, ["value", "color"])]), _createElementVNode("div", _hoisted_5, [_createVNode(Progress, {
        value: _unref(progressAwayValue),
        color: __props.color,
        "show-value": ""
      }, {
        value: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(progressAwayValueLabel)), 1)]),
        _: 1
      }, 8, ["value", "color"])])])]);
    };
  }
});